module.exports = __webpack_public_path__ + "img/world-sm.f1a73b22.svg";